import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/companies";

const { actions, types } = createActions({
  addCompany: ["company", "onSuccess", "onFailure"],
  updateCompany: ["id", "company", "onSuccess", "onFailure"],
  setLoading: ["loading"],
  fetchCompanyRequest: ["page", "perPage", "onFailure"],
  setInitialFetchIsDone: [],
  setCompanyTotalItems: ["totalItems"],
  setCompaniesPerPage: ["perPage"],
  setCompanyPage: ["page"],
  addCompanies: ["companies"],

  storeCompanyAdmin: ["id", "user", "onSuccess", "onFailure"],
  storeUltipro: ["id", "ultipro", "onSuccess", "onFailure"],
  storeUta: ["id", "uta", "onSuccess", "onFailure"],
  storeSimplitime: ["id", "simplitime", "onSuccess", "onFailure"],

  fetchSettings: ["onFailure", "onSuccess"],
  addSettings: ["company"],
});

const reducer = createReducer(initialState, {
  [types.ADD_COMPANIES]: (state, { payload }) => ({
    ...state,
    companies: [...payload.companies],
  }),
  [types.SET_LOADING]: (state, { payload }) => ({
    ...state,
    loading: payload.loading,
  }),
  [types.SET_INITIAL_FETCH_IS_DONE]: (state) => ({
    ...state,
    initialFetchIsDone: true,
  }),
  [types.SET_COMPANY_TOTAL_ITEMS]: (state, { payload }) => ({
    ...state,
    totalItems: payload.totalItems,
  }),
  [types.SET_COMPANY_PAGE]: (state, { payload }) => ({
    ...state,
    page: payload.page,
  }),
  [types.SET_COMPANIES_PER_PAGE]: (state, { payload }) => ({
    ...state,
    perPage: payload.perPage,
  }),
  [types.ADD_SETTINGS]: (state, { payload }) => ({
    ...state,
    settings: {
      fetched: true,
      company: payload.company,
    },
  }),
  [types.FETCH_SETTINGS]: (state) => ({
    ...state,
    settings: {
      fetched: false,
      company: undefined,
    },
  }),
});

export { reducer as default, types, actions };
